import { render, staticRenderFns } from "./AdminAttentionPanel.vue?vue&type=template&id=386854c2&scoped=true"
import script from "./AdminAttentionPanel.vue?vue&type=script&lang=js"
export * from "./AdminAttentionPanel.vue?vue&type=script&lang=js"
import style0 from "./AdminAttentionPanel.vue?vue&type=style&index=0&id=386854c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386854c2",
  null
  
)

export default component.exports